<template>
  <div class="content">
    <card>
      <h4 slot="header" class="card-title">Downloads</h4>
      <div class="accordion" id="accordionExample">
        <div
          class="card border-bottom-1"
          v-for="(category, index) in categories"
          v-bind:key="index"
        >
          <div class="card-header" :id="'heading-' + index">
            <h5>
              <a
                href=""
                data-toggle="collapse"
                :data-target="'#collapse' + index"
                aria-expanded="true"
                :aria-controls="'collapse' + index"
                ><strong>{{ category.name }}</strong></a
              >
            </h5>
          </div>
          <div
            :id="'collapse' + index"
            class="collapse show"
            :aria-labelledby="'heading-' + index"
            data-parent="#accordionExample"
          >
            <div class="card-body">
              <div class="row pl-4 pr-4">
                <div
                  class="file col-lg-3 col-md-3 col-sm-6 col-12"
                  v-for="(file, index) in category.files"
                  v-bind:key="index"
                >
                  <a :href="file.url" target="_blank" class="item-file">
                    <img
                      src="../../public/img/pdf.jpg"
                      alt=""
                      style="width: 5em"
                    />
                    <span>{{ file.name }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import Card from 'src/components/Cards/Card.vue';

export default {
  components: {
    Card
  },
  data() {
    return {
      categories: [
        {
          name: 'Manuais',
          files: [
            {
              name: 'GD-P-001 - ESTRUTURA SOLO - MANUAL DE MONTAGEM].pdf',
              url:
                'https://drive.google.com/open?id=1a_H5iwKcm_CBdFpuNBlqgj-Wl6-cc6Sy'
            },
            {
              name: 'GD-P-002 - TESTE OTIMIZADOR.pdf',
              url:
                'https://drive.google.com/open?id=1_RoG_W-wb22xIp0OuF6kfOP5PxnVPGgp'
            },
            {
              name: 'GD-P-003 - MANUAL DE OPERAÇÃO.pdf',
              url:
                'https://drive.google.com/open?id=1mqSqouim-erxHbkdG_gdRDTjoYhDOBYa'
            }
          ]
        },
        {
          name: 'Procedimentos',
          files: [
            {
              name: 'GD-P-001 - MEDIDOR BIDIRECIONAL.pdf',
              url:
                'https://drive.google.com/open?id=1Rh-MmqjQjY7Y8SwyRGbR39q4w_kvjxsZ'
            },
            {
              name: 'GD-P-002 - COMISSIONAMENTO.pdf',
              url:
                'https://drive.google.com/open?id=1aAPCwfgT8Bc3tqaHXBa2FJSZG3jbjul0'
            },
            {
              name: 'GD-P-003 - ACESSO A FATURA DE ENERGIA.pdf',
              url:
                'https://drive.google.com/open?id=17XtRlHVrFoErZf1WfD6UOh44SP57BrOB'
            }
          ]
        },
        {
          name: 'Comercial',
          files: [
            {
              name: 'GD-C-01 - DADOS CADASTRAIS.pdf',
              url:
                'https://drive.google.com/open?id=1SMrncrOhDgisNacbxJeVpwY5YRzPBW-D'
            },
            {
              name: 'GD-C-02 - APRESENTAÇÃO JOULE ENERGIA SOLAR.pdf',
              url:
                'https://drive.google.com/open?id=1MyYjI2gps5zS4u1fXPOh6jSZWOyP8BW8'
            }
          ]
        }
      ]
    };
  },
  methods: {}
};
</script>
<style>
.border-bottom-1 {
  border-bottom: 1px !important;
  border-bottom-width: 1px !important;
}
a {
  color: black;
}
.file {
  margin-bottom: 2%;
}
.item-file {
  display: grid;
  text-align: center;
  justify-items: center;
}
.p-h-1 {
  padding-right: 1em;
  padding-left: 1em;
}
</style>
